;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="11e1b32b-5b08-4b3e-83c1-282ea7a7a7a0",e._sentryDebugIdIdentifier="sentry-dbid-11e1b32b-5b08-4b3e-83c1-282ea7a7a7a0")}catch(e){}}();import loadable from '@loadable/component';
import dynamic from 'next/dynamic';
import '../../_virtual/_sentry-release-injection-file.js';

const getBonusPoints = (isNextJS) => {
    if (isNextJS) {
        return dynamic(async () => {
            const pkg = await import('@zooplus/bonus-points-web-components');
            return pkg.AccountNavigationBox;
        }, {
            ssr: false,
        });
    }
    return loadable(async () => {
        const pkg = await import('@zooplus/bonus-points-web-components');
        return pkg.AccountNavigationBox;
    });
};

export { getBonusPoints as default };
//# sourceMappingURL=BonusPointsWrapper.js.map
